import { createContext, createElement, useContext, useMemo, useState } from 'react'
import type { ReactNode } from 'react'

type OpenRequest = {
  /** Counts the openings, so each one starts the popover afresh. */
  seq: number
}

type AddFilesContextValue = {
  /** Open while set. */
  request: OpenRequest | undefined
  open: () => void
  close: () => void
}

export const AddFilesContext = createContext<AddFilesContextValue>({ request: undefined, open: () => undefined, close: () => undefined })

/** The "Add files" popover's state, shared so the page overlay can stay out of its way while it is open. */
export const AddFilesProvider = ({ children }: { children: ReactNode }) => {
  const [request, setRequest] = useState<OpenRequest>()
  const value = useMemo(
    () => ({
      request,
      open: () => setRequest((current) => ({ seq: (current?.seq ?? 0) + 1 })),
      close: () => setRequest(undefined)
    }),
    [request]
  )
  return createElement(AddFilesContext.Provider, { value }, children)
}

export const useAddFiles = () => useContext(AddFilesContext)
